module.exports = __webpack_public_path__ + "img/Steve Marshall.b54ed055.jpg";